export default "__VITE_PUBLIC_ASSET__92078937__"